export const TOKEN_KEY =
  `genedata_auth_token${import.meta.env.DEV ? "" : `_${location.pathname.split("/")[1]}`}` as const;
